import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../MyPage.js";
import SubTabsWarehouses from "../../SubTabsWarehouses.js";
import { isSuperAdmin } from "./../../helpers/user.js";
import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';

import { saveAs } from 'file-saver';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { SatelliteContext } from '../../context/SatelliteContext';
import { appendSatelliteToSearchParams, applySatelliteQueryToUrl } from '../../helpers/satellite';
import InventoriesTable from '../../components/InventoriesTable';

  export default class WarehousesInventories extends Component{
    static contextType = SatelliteContext;

    constructor(props){
      super(props);

      this.state={
          isDownloading: false,
          inventories:[],
          modalTitle:"",
          inventoryid:0,
          warehouseid: 0,
          yearid: 0,
          productid:0,
          satellite: "",
          july:"",
          august:"",
          september:"",
          october: "",
          november: "",
          december: "",
          january: "",
          february: "",
          march: "",
          april: "",
          may: "",
          june:"",

          year: {
            yearid: 0,
            fyname: "",
            isactive: false
          },
          warehouse: {
            warehouseid: 6,
            warehousename: "",
            covertime:"",
          },
          product: {
            productid: 0,
            sapcode: "",
            productdescription: ""
          },
  
    
          CountryNameFilter:"",
          WarehouseNameFilter:"",
          FiscalYearFilter:"",
          ProductDescriptionFilter:"",
          InventoryIdFilter:"",
          CurrentYearFilter:"",
          ProductIdFilter:"",
          inventoriesWithoutFilter:[],
          regionNames: [],
          countryNames: [],
          fiscalYears: [], 
          productdescriptions: [],
          containerdescriptions: [],
          warehouseNames: [],
          loading: true,
          loadingExp: true,
          currentYearIndex: 0,
          currentYear: null,
          isEditClicked: false,
          initialSatellite: "",
          SapcodeNames:[],
          SapcodeDescriptionNames:[],
          fiscalYearsData:[],
          uniqueProductsDescriptions:[],
          uniqueWarehouses:[],


          exp_inventories:[],
          inventoryexpid:0 ,
		fyname: "",
		warehousename: "",
		itemtypename: "",
		//productid: 0,
		sapcode: "",
		productdescription: "",
		tf_numbers: "",
		tf_total_value: "",
		tf_july: "",
		tf_august: "",
		tf_september: "",
		tf_october: "",
		tf_november: "",
		tf_december: "",
		tf_january: "",
		tf_february: "",
		tf_march: "",
		tf_april: "",
		tf_may: "",
		tf_june: "",

    ExpWarehouseNameFilter:"",
    ToWarehouseNameFilter:"",
          ExpFiscalYearFilter:"",
          ExpProductDescriptionFilter:"",
          ExpInventoryexpIdFilter:"",
          ExpItemtypeNameFilter:"",
          ExpSapCodeFilter:"",
          exp_inventoriesWithoutFilter:[],

          uniqueRowConcat:[],

          file: null,
          message: '',
          errors: [],
          

          currentPage: 1,
          totalPages: 1,
          pageSize: 100,
          nextPageUrl: null,
          previousPageUrl: null,

          currentPageExp: 1,
          totalPagesExp: 1,
          pageSizeExp: 100,
          nextPageUrlExp: null,
          previousPageUrlExp: null
      };



      this.handleNextPageExp = this.handleNextPageExp.bind(this);
      this.handlePreviousPageExp = this.handlePreviousPageExp.bind(this);
      this.searchExpInventories = this.searchExpInventories.bind(this);
      this.clearFiltersExp = this.clearFiltersExp.bind(this);

      this.handleNextPage = this.handleNextPage.bind(this);
      this.handlePreviousPage = this.handlePreviousPage.bind(this);
      this.handleFileChange = this.handleFileChange.bind(this);
      this.handleUpload = this.handleUpload.bind(this);
      this.downloadCSV = this.downloadCSV.bind(this);
      this.refreshList = this.refreshList.bind(this);


      
  }

  appendInventoriesSatelliteParam(queryParams) {
    appendSatelliteToSearchParams(queryParams, this.context?.satellite);
  }

  applySatelliteToInventoriesUrl(url) {
    return applySatelliteQueryToUrl(url || '/inventories/', this.context?.satellite);
  }

  handleUpload = async () => {
    const { file } = this.state;
    if (!file) {
      alert('Please select a file to upload.');
      return;
    }
  
    const formData = new FormData();
    formData.append('file', file);
  
    try {
      const response = await axiosService.post('/inventoriesupload/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      const data = response.data;
      this.setState({ message: 'File uploaded successfully.', errors: [] });
      alert('File uploaded successfully.');
      window.location.reload();
  
    } catch (error) {
      let errorMessage = 'Upload failed';
      
      if (error.response?.data?.errors && error.response.data.errors.length > 0) {
        const errorList = error.response.data.errors.map(err => `Row ${err.row}: ${err.error}`).join('\n');
        errorMessage += `\n\nErrors:\n${errorList}`;
      }
      
      this.setState({ message: errorMessage, errors: [] });
      alert(errorMessage);
      window.location.reload();
    }
  };
  


  handleFileChange = (event) => {
    this.setState({ file: event.target.files[0] });
  };

async downloadCSV() {
  this.setState({ isDownloading: true });
  
  try {
    const queryParams = new URLSearchParams();
    this.appendInventoriesSatelliteParam(queryParams);
    const qs = queryParams.toString();
    const response = await axiosService.get(`/inventories/download_csv/${qs ? `?${qs}` : ''}`, {
      responseType: 'blob'
    });

    const blob_ = response.data;
    const url = window.URL.createObjectURL(blob_);
    const a = document.createElement('a');
    a.href = url;
    a.download = `inventories_${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    
  } catch (error) {
    console.error('Error downloading CSV:', error);
    alert('Failed to download CSV file. Please try again.');
  } finally {
    this.setState({ isDownloading: false });
  }
}





  FilterFn(){
    var CountryNameFilter = this.state.CountryNameFilter;
    var WarehouseNameFilter = this.state.WarehouseNameFilter;
    var FiscalYearFilter = this.state.FiscalYearFilter;
    var ProductDescriptionFilter = this.state.ProductDescriptionFilter;
    var InventoryIdFilter = this.state.InventoryIdFilter;
    var CurrentYearFilter = this.state.CurrentYearFilter;
    var ProductIdFilter = this.state.ProductIdFilter;

    var filteredData=this.state.inventoriesWithoutFilter.filter(
        function(el){
            return el.warehouse.country.countryname.toString().toLowerCase().includes(
                CountryNameFilter.toString().trim().toLowerCase()
            )&&  
                el.warehouse.warehousename.toString().toLowerCase().includes(
                WarehouseNameFilter.toString().trim().toLowerCase()
            )&&  
                el.year.fyname.toString().toLowerCase().includes(
                FiscalYearFilter.toString().trim().toLowerCase()
            )&&  
                el.product.productdescription.toString().toLowerCase().includes(
                ProductDescriptionFilter.toString().trim().toLowerCase()
            )&&  
                el.inventoryid.toString().toLowerCase().includes(
                InventoryIdFilter.toString().trim().toLowerCase()
            )&&  
            el.product.sapcode.toString().toLowerCase().includes(
            ProductIdFilter.toString().trim().toLowerCase()
        )
        }
    );

    this.setState({inventories:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.inventoriesWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({inventories:sortedData});

}


FilterFnExp(){
  var ExpWarehouseNameFilter = this.state.ExpWarehouseNameFilter;
  var ToWarehouseNameFilter = this.state.ToWarehouseNameFilter;
  var ExpFiscalYearFilter = this.state.ExpFiscalYearFilter;
  var ExpProductDescriptionFilter = this.state.ExpProductDescriptionFilter;
  var ExpInventoryexpIdFilter = this.state.ExpInventoryexpIdFilter;
  var ExpItemtypeNameFilter = this.state.ExpItemtypeNameFilter;
  var ExpSapCodeFilter = this.state.ExpSapCodeFilter;

  var filteredData=this.state.exp_inventoriesWithoutFilter.filter(
      function(el){
          return el.warehousename.toString().toLowerCase().includes(
              ExpWarehouseNameFilter.toString().trim().toLowerCase()
          )&&
              el.fyname.toString().toLowerCase().includes(
              ExpFiscalYearFilter.toString().trim().toLowerCase()
          )&&  
              el.inventoryexpid.toString().toLowerCase().includes(
              ExpInventoryexpIdFilter.toString().trim().toLowerCase()
          )&&  
          el.productdescription.toString().toLowerCase().includes(
            ExpProductDescriptionFilter.toString().trim().toLowerCase()
      )&&    
      el.itemtypename.toString().toLowerCase().includes(
        ExpItemtypeNameFilter.toString().trim().toLowerCase()
  )&&  
  el.sapcode.toString().toLowerCase().includes(
    ExpSapCodeFilter.toString().trim().toLowerCase()
)
      }
  );

  this.setState({exp_inventories:filteredData});

}

sortResultExp(prop,asc){
var sortedData=this.state.exp_inventoriesWithoutFilter.sort(function(a,b){
    if(asc){
        return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
    }
    else{
        return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
    }
});

this.setState({exp_inventories:sortedData});

}


changeCountryNameFilter = (e) => {
  this.setState({ CountryNameFilter: e.target.value });
}

changeWarehouseNameFilter = (e) => {
  this.setState({ WarehouseNameFilter: e.target.value });
}

changeFiscalYearFilter = (e) => {
  this.setState({ FiscalYearFilter: e.target.value });
}

changeProductDescriptionFilter = (e) => {
  this.setState({ ProductDescriptionFilter: e.target.value });
}

changeInventoryIdFilter = (e) => {
  this.setState({ InventoryIdFilter: e.target.value });
}

changeCurrentYearFilter = (e) => {
  this.setState({ CurrentYearFilter: e.target.value });
}

changeProductIdFilter = (e) => {
  this.setState({ ProductIdFilter: e.target.value });
}


  changeExpWarehouseNameFilter = (e)=>{
    this.state.ExpWarehouseNameFilter=e.target.value;
    this.FilterFnExp();
  }



  changeExpFiscalYearFilter = (e)=>{
    this.state.ExpFiscalYearFilter=e.target.value;
    this.FilterFnExp();
  }


  
changeExpInventoryexpIdFilter = (e)=>{
  this.state.ExpInventoryexpIdFilter=e.target.value;
  this.FilterFnExp();
}

changeExpProductDescriptionFilter = (e)=>{
  this.state.ExpProductDescriptionFilter=e.target.value;
  this.FilterFnExp();
}


changeExpItemtypeNameFilter = (e)=>{
  this.state.ExpItemtypeNameFilter=e.target.value;
  this.FilterFnExp();
}

changeExpSapCodeFilter = (e)=>{
  this.state.ExpSapCodeFilter=e.target.value;
  this.FilterFnExp();
}

searchInventories = () => {
  const {
    CountryNameFilter,
    WarehouseNameFilter,
    FiscalYearFilter,
    ProductDescriptionFilter,
    ProductIdFilter
  } = this.state;

  // Build query parameters
  const queryParams = new URLSearchParams();
  
  if (FiscalYearFilter) {
    queryParams.append('year', FiscalYearFilter);
  }
  if (WarehouseNameFilter) {
    queryParams.append('warehouse', WarehouseNameFilter);
  }
  if (CountryNameFilter) {
    queryParams.append('country', CountryNameFilter);
  }
  if (ProductDescriptionFilter) {
    queryParams.append('product', ProductDescriptionFilter);
  }
  if (ProductIdFilter) {
    queryParams.append('sapcode', ProductIdFilter);
  }

  this.appendInventoriesSatelliteParam(queryParams);

  // Show loading state
  this.setState({ loading: true });

  // Call the API
  const queryString = queryParams.toString();
  const endpoint = `/inventories/${queryString ? '?' + queryString : ''}`;
  axiosService.get(endpoint)
    .then((response) => {
      const data = response.data;
      this.setState({ 
        inventories: data.results || data, 
        inventoriesWithoutFilter: data.results || data,
        loading: false,
        nextPageUrl: data.next,
        previousPageUrl: data.previous,
        totalPages: data.count ? Math.ceil(data.count / this.state.pageSize) : 1,
        currentPage: 1
      });
    })
    .catch((error) => {
      console.error('Error searching inventories:', error);
      alert('Failed to search inventories');
      this.setState({ loading: false });
    });
};


clearFilters = () => {
  this.setState({
    CountryNameFilter: "",
    WarehouseNameFilter: "",
    FiscalYearFilter: "",
    ProductDescriptionFilter: "",
    InventoryIdFilter: "",
    CurrentYearFilter: "",
    ProductIdFilter: ""
  }, () => {
    // Clear all input fields in the DOM
    const filterInputs = document.querySelectorAll('.form-control');
    filterInputs.forEach(input => {
      if (input.placeholder === 'Filter') {
        input.value = '';
      }
    });
    // Show loading state
    this.setState({ loading: true });
    // Reload all data after clearing filters
    this.refreshList();
  });
};


refreshList = (url = null) => {
  const apiUrl = this.applySatelliteToInventoriesUrl(url || '/inventories/');

  axiosService.get(apiUrl)
    .then((response) => {
      const data = response.data;
      // Calculate total pages
      const totalPages = Math.ceil(data.count / this.state.pageSize);
      // console.log("data.previous===>", data.previous)
      this.setState({ 
        inventories: data.results, 
        inventoriesWithoutFilter: data.results, 
        loading: false,
        nextPageUrl: data.next,
        previousPageUrl: data.previous,
        totalPages: totalPages
      });
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
      this.setState({ loading: false });
    });
};


// Handle next page
handleNextPage = () => {
  if (this.state.nextPageUrl) {
    this.setState({ 
      loading: true,
      currentPage: this.state.currentPage + 1 
    });
    this.refreshList(this.state.nextPageUrl);
  }
};

// Handle previous page
handlePreviousPage = () => {
  if (this.state.previousPageUrl) {
    this.setState({ 
      loading: true,
      currentPage: this.state.currentPage - 1 
    });
    this.refreshList(this.state.previousPageUrl);
  }
};


handleNextPageExp = () => {
  if (this.state.nextPageUrlExp) {
    this.setState({ 
      loadingExp: true,
      currentPageExp: this.state.currentPageExp + 1 
    });
    this.refreshListExp(this.state.nextPageUrlExp);
  }
};

handlePreviousPageExp = () => {
  if (this.state.previousPageUrlExp) {
    this.setState({ 
      loadingExp: true,
      currentPageExp: this.state.currentPageExp - 1 
    });
    this.refreshListExp(this.state.previousPageUrlExp);
  }
};



// 5. UPDATE FILTER CHANGE HANDLERS (REMOVE FilterFnExp CALLS)
changeExpWarehouseNameFilter = (e) => {
  this.setState({ ExpWarehouseNameFilter: e.target.value });
}

changeExpFiscalYearFilter = (e) => {
  this.setState({ ExpFiscalYearFilter: e.target.value });
}

changeExpInventoryexpIdFilter = (e) => {
  this.setState({ ExpInventoryexpIdFilter: e.target.value });
}

changeExpProductDescriptionFilter = (e) => {
  this.setState({ ExpProductDescriptionFilter: e.target.value });
}

changeExpItemtypeNameFilter = (e) => {
  this.setState({ ExpItemtypeNameFilter: e.target.value });
}

changeExpSapCodeFilter = (e) => {
  this.setState({ ExpSapCodeFilter: e.target.value });
}


searchExpInventories = () => {
  const {
    ExpWarehouseNameFilter,
    ExpFiscalYearFilter,
    ExpProductDescriptionFilter,
    ExpItemtypeNameFilter,
    ExpSapCodeFilter
  } = this.state;

  // Build query parameters
  const queryParams = new URLSearchParams();
  
  if (ExpFiscalYearFilter) {
    queryParams.append('year', ExpFiscalYearFilter);
  }
  if (ExpWarehouseNameFilter) {
    queryParams.append('warehouse', ExpWarehouseNameFilter);
  }
  if (ExpProductDescriptionFilter) {
    queryParams.append('product', ExpProductDescriptionFilter);
  }
  if (ExpItemtypeNameFilter) {
    queryParams.append('itemtype', ExpItemtypeNameFilter);
  }
  if (ExpSapCodeFilter) {
    queryParams.append('sapcode', ExpSapCodeFilter);
  }

  this.appendInventoriesSatelliteParam(queryParams);

  // Show loading state
  this.setState({ loadingExp: true });

  // Call the API
  const queryString = queryParams.toString();
  const endpoint = `/inventories_exp/${queryString ? '?' + queryString : ''}`;
  axiosService.get(endpoint)
    .then((response) => {
      const data = response.data;
      this.setState({ 
        exp_inventories: data.results || data, 
        exp_inventoriesWithoutFilter: data.results || data,
        loadingExp: false,
        nextPageUrlExp: data.next,
        previousPageUrlExp: data.previous,
        totalPagesExp: data.count ? Math.ceil(data.count / this.state.pageSizeExp) : 1,
        currentPageExp: 1
      });
    })
    .catch((error) => {
      console.error('Error searching exp inventories:', error);
      alert('Failed to search planned inventories');
      this.setState({ loadingExp: false });
    });
};

clearFiltersExp = () => {
  this.setState({
    ExpWarehouseNameFilter: "",
    ExpFiscalYearFilter: "",
    ExpProductDescriptionFilter: "",
    ExpInventoryexpIdFilter: "",
    ExpItemtypeNameFilter: "",
    ExpSapCodeFilter: ""
  }, () => {
    // Clear all input fields in the DOM for exp inventory section
    const filterInputs = document.querySelectorAll('.form-control');
    filterInputs.forEach(input => {
      if (input.placeholder === 'Filter') {
        input.value = '';
      }
    });
    // Show loading state
    this.setState({ loadingExp: true });
    // Reload all data after clearing filters
    this.refreshListExp();
  });
};

  fetchUniqueRowConcat() {
    axiosService.get('/inventories/')
      .then(response => {
        const data = response.data;
        const result = Array.from(
          new Set(
            data.results.map((item) => {
              const sat = item.satellite ?? item.product?.satellite ?? "";
              return `${item.year.fyname}${item.warehouse.warehousename}${item.product.productdescription}${sat}`;
            })
          )
        );
        this.setState({ uniqueRowConcat: result });
      })
      .catch(error => {
        console.error("Error fetching concatList:", error);
      });
  }


  refreshListExp = (url = null) => {
    const apiUrl = applySatelliteQueryToUrl(url || '/inventories_exp/', this.context?.satellite);

    axiosService.get(apiUrl)
      .then((response) => {
        const data = response.data;
        // Calculate total pages
        const totalPagesExp = Math.ceil(data.count / this.state.pageSizeExp);
        
        this.setState({ 
          exp_inventories: data.results, 
          exp_inventoriesWithoutFilter: data.results, 
          loadingExp: false,
          nextPageUrlExp: data.next,
          previousPageUrlExp: data.previous,
          totalPagesExp: totalPagesExp
        });
      })
      .catch((error) => {
        console.error('Error fetching exp data:', error);
        this.setState({ loadingExp: false });
      });
  };



fetchRegionNames() {
  axiosService.get('/regionnames/')
    .then(response => {
      const data = response.data;
      const regionNames = data.map(item => item.regionname);
      this.setState({ regionNames: regionNames });
    })
    .catch(error => {
      console.error("Error fetching region names:", error);
    });
}


fetchCountryNames() {
  axiosService.get('/countries/')
    .then(response => {
      const data = response.data;
      const countryNames = data.map(item => item.countryname);
      this.setState({ countryNames: countryNames });
    })
    .catch(error => {
      console.error("Error fetching country names:", error);
    });
}

fetchFiscalYears() {
    axiosService.get('/years/')
      .then(response => {
        const data = response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const fiscalYears = filteredData.map(item => item.fyname);
        this.setState({ fiscalYears: fiscalYears });
      })
      .catch(error => {
        console.error("Error fetching fiscal years:", error);
      });
  }

  fetchProductDescriptions() {
    axiosService.get('/defaultproducts/')
      .then(response => {
        const data = response.data;
        const filteredData = data.filter(item => item.isactive === true && item.productlabelid === 1);
        const productdescriptions = filteredData.map(item => item.productdescription);
        this.setState({ productdescriptions: productdescriptions });
      })
      .catch(error => {
        console.error("Error fetching products :", error);
      });
  }


  
  fetchSapcodeNames() {
    axiosService.get('/defaultproducts/')
      .then(response => {
        const data = response.data;
        const filteredData = data.filter(item => item.isactive === true && item.productlabelid===1);
        const SapcodeNames = filteredData.map(item => item.sapcode);
  
        const sapcodeToProductDescriptionMap = {};
        filteredData.forEach(item => {
          sapcodeToProductDescriptionMap[item.sapcode] = item.productdescription;
        });
  
        this.setState({ SapcodeNames: SapcodeNames,SapcodeDescriptionNames:sapcodeToProductDescriptionMap  });
      })
      .catch(error => {
        console.error("Error fetching product sapcode:", error);
      });
  }
  
  findProductDescriptionForSapcode(sapcode) {
    const productDescriptionMap = this.state.SapcodeDescriptionNames;
    return productDescriptionMap[sapcode] || "Product not found";
  }
 
  fetchWarehouseNames() {
    axiosService.get('/warehouses/')
      .then(response => {
        const data = response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const warehouseNames = filteredData.map(item => item.warehousename);
        this.setState({ warehouseNames: warehouseNames });
      })
      .catch(error => {
        console.error("Error fetching warehouse names:", error);
      });
  }

handleInput = (event) => {
    const inputValue = event.target.value;
    const regex = /^\d*$/;
    if (!regex.test(inputValue)) {
      event.target.value = inputValue.replace(/[^0-9]/g, '');
    }
  };

  handleScrollRight = () => {
    this.setState((prevState) => ({
      currentYearIndex: Math.min(prevState.currentYearIndex + 1, prevState.fiscalYears.length - 1),
    }));
  };
  
  handleScrollLeft = () => {
    this.setState((prevState) => ({
      currentYearIndex: Math.max(prevState.currentYearIndex - 1, 0),
    }));
  };

  componentDidUpdate(prevProps, prevState) {
    // Check if the currentYearIndex has changed, if so, update the currentYear
    if (prevState.currentYearIndex !== this.state.currentYearIndex) {
      this.updateCurrentYear();
    }
    const sat = this.context?.satellite;
    if (this._lastInventoriesSatellite !== sat) {
      this._lastInventoriesSatellite = sat;
      this.setState({ loading: true, loadingExp: true });
      this.refreshList();
      this.refreshListExp();
    }
  }


  updateCurrentYear() {
    // Get the current year from fiscalYears based on currentYearIndex
    const { fiscalYears, currentYearIndex } = this.state;
    const currentYear = fiscalYears[currentYearIndex];

    // Update the state with the new currentYear
    this.setState({ currentYear });
  }

  fetchFiscalYearsData() {
    axiosService.get('/inventories/')
      .then(response => {
        const data = response.data;
        const uniqueFiscalYears = [...new Set(data.results.map((item) => item.year.fyname))];
        this.setState({ fiscalYearsData: uniqueFiscalYears });
      })
      .catch(error => {
        console.error("Error fetching products :", error);
      });
  } 

  fetchProductDescriptionsData() {
    axiosService.get('/inventories/') // Replace with the appropriate API endpoint for products
      .then((response) => {
        const data = response.data;
        const uniqueProductDescriptions = [...new Set(data.results.map((item) => item.product.productdescription))];
        this.setState({ uniqueProductsDescriptions: uniqueProductDescriptions });
      })
      .catch((error) => {
        console.error('Error fetching products data:', error);
      });
  }

  fetchWarehousesData() {
    axiosService.get('/inventories/') // Replace with the appropriate API endpoint for products
      .then((response) => {
        const data = response.data;
        const uniqueWrehousesnames = [...new Set(data.results.map((item) => item.warehouse.warehousename))];
        this.setState({ uniqueWarehouses: uniqueWrehousesnames });
      })
      .catch((error) => {
        console.error('Error fetching products data:', error);
      });
  }

componentDidMount(){
  this._lastInventoriesSatellite = this.context?.satellite;
  this.refreshList();
  this.fetchRegionNames();
  this.fetchCountryNames();
  this.fetchFiscalYears();
  this.fetchProductDescriptions();
  this.fetchWarehouseNames();
  this.updateCurrentYear();
  this.fetchSapcodeNames();
  this.fetchFiscalYearsData();
  this.fetchWarehousesData();
  this.fetchProductDescriptionsData();
  this.refreshListExp();
  this.fetchUniqueRowConcat();
}

changeCountryName =(e)=>{
  this.setState({countryname:e.target.value});
}


changeRegionName =(e)=>{
  this.setState({regionname:e.target.value});
}

changeFiscalYear =(e)=>{
    this.setState({fyname:e.target.value});
  }

changeProductDescription =(e)=>{
    this.setState({productdescription:e.target.value});
  }

changeJuly =(e)=>{
    this.setState({july:e.target.value});
  }

changeAugust =(e)=>{
    this.setState({august:e.target.value});
  }

changeSeptember =(e)=>{
    this.setState({september:e.target.value});
  }

changeOctober =(e)=>{
    this.setState({october:e.target.value});
  }
changeNovember =(e)=>{
    this.setState({november:e.target.value});
  }

changeDecember =(e)=>{
    this.setState({december:e.target.value});
  }

changeJanuary=(e)=>{
    this.setState({january:e.target.value});
  }

changeFebruary =(e)=>{
    this.setState({february:e.target.value});
  }

changeMarch =(e)=>{
    this.setState({march:e.target.value});
  }

changeApril =(e)=>{
    this.setState({april:e.target.value});
  }

changeMay =(e)=>{
    this.setState({may:e.target.value});
  }

changeJune =(e)=>{
    this.setState({june:e.target.value});
  }



addClick(){
  this.setState({
      modalTitle:"Add Inventory",
      inventoryid:0,
      warehousename:"",
      fyname:"",
      productdescription:"",
      satellite: "",
      july:"",
      august:"",
      september:"",
      october:"",
      november:"",
      december:"",
      january:"",
      february:"",
      march:"",
      april:"",
      may:"",
      june:"",
      isEditClicked: false,
  });
}


editClick(dep) {
  this.setState({
    modalTitle: "Edit Inventory",
    inventoryid: dep.inventoryid,
    warehousename:dep.warehouse.warehousename,
    fyname:dep.year.fyname,
    sapcode:dep.product.sapcode,
    productdescription:dep.product.productdescription,
    satellite: dep.satellite ?? dep.product?.satellite ?? "",
    july:dep.july,
    august:dep.august,
    september:dep.september,
    october:dep.october,
    november:dep.november,
    december:dep.december,
    january:dep.january,
    february:dep.february,
    march:dep.march,
    april:dep.april,
    may:dep.may,
    june:dep.june,
    initialWarehousename:dep.warehouse.warehousename,
    initialFyname:dep.year.fyname,
    initialProductdescription:dep.product.productdescription,
    initialSatellite: dep.satellite ?? dep.product?.satellite ?? "",
    initialJuly:dep.july,
    initialAugust:dep.august,
    initialSeptember:dep.september,
    initialOctober:dep.october,
    initialNovember:dep.november,
    initialDecember:dep.december,
    initialJanuary:dep.january,
    initialFebruary:dep.february,
    initialMarch:dep.march,
    initialApril:dep.april,
    initialMay:dep.may,
    initialJune:dep.june,
    isEditClicked: true,
  });
}

createClick() {
  const {  warehousename, fyname, productdescription, satellite, july, august, september, october,
  november, december, january, february, march, april, may, june, fiscalYearsData, uniqueWarehouses, uniqueProductsDescriptions, uniqueRowConcat } = this.state;

  if (!warehousename) {
    alert('Warehouse is required');
    return;
  }


  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }

  /*

  if (fiscalYearsData.includes(parseInt(fyname)) && uniqueWarehouses.some(name => name.toLowerCase() === warehousename.toLowerCase()) && uniqueProductsDescriptions.some(name => name.toLowerCase() === productdescription.toLowerCase())) {
    alert('This Product already exists for the current Fiscal Year and current warehouse. Please provide the Fiscal Year and Warehouse or modify the existing record');
    return;
  }

  */

  if (uniqueRowConcat.includes(`${fyname}${warehousename}${productdescription}${satellite || ""}`)) {
    alert('This record already exists. Modify your information or modify the existing record');
    return;
  }
 
  axiosService.post('/inventoriescreate/', {
    warehousename: warehousename,
    fyname: fyname,
    productdescription:productdescription,
    satellite: satellite,
    july:july,
    august:august,
    september:september,
    october:october,
    november:november,
    december:december,
    january:january,
    february:february,
    march:march,
    april:april,
    may:may,
    june:june
  })
    .then(result => {
      alert('Inventory created');
      window.location.reload();
      this.refreshList();
    })
    .catch(error => {
      alert('Failed');
    });
}

updateClick(id) {
  const {  warehousename, fyname, productdescription, satellite, july, august, september, october,
    november, december, january, february, march, april, may, june,
    initialWarehousename, initialFyname, initialProductdescription, initialSatellite, initialJuly, initialAugust,
    initialSeptember, initialOctober, initialNovember, initialDecember, initialJanuary,
    initialFebruary, initialMarch, initialApril, initialMay, initialJune  } = this.state;

  if (
    warehousename === initialWarehousename&&
    fyname === initialFyname &&
    productdescription === initialProductdescription &&
    satellite === initialSatellite &&
    july === initialJuly &&
    august === initialAugust &&
    september === initialSeptember &&
    october === initialOctober &&
    november === initialNovember &&
    december === initialDecember &&
    january === initialJanuary &&
    february === initialFebruary &&
    march === initialMarch &&
    april === initialApril &&
    may === initialMay &&
    june === initialJune
  ) {
    alert('No changes detected');
    return;
  }


  if (!warehousename) {
    alert('Warehouse is required');
    return;
  }


  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }

  
  axiosService.patch('/inventories/' + id + '/', {
    warehousename: this.state.warehousename,
    fyname: this.state.fyname,
    productdescription : this.state.productdescription,
    satellite: this.state.satellite,
    july : this.state.july,
    august : this.state.august,
    september : this.state.september,
    october : this.state.october,
    november : this.state.november,
    december : this.state.december,
    january : this.state.january,
    february : this.state.february,
    march : this.state.march,
    april : this.state.april,
    may : this.state.may,
    june : this.state.june
  })
    .then(result => {
      alert('Update successful');
      this.refreshList();
    })
    .catch(error => {
      alert('Failed');
    });
}


copyClick() {
  const {  warehousename, fyname, productdescription, satellite, july, august, september, october,
    november, december, january, february, march, april, may, june,
    initialWarehousename, initialFyname, initialProductdescription, initialJuly, initialAugust,
    initialSeptember, initialOctober, initialNovember, initialDecember, initialJanuary,
    initialFebruary, initialMarch, initialApril, initialMay, initialJune, fiscalYearsData, uniqueWarehouses, uniqueProductsDescriptions,uniqueRowConcat  } = this.state;


  if (!warehousename) {
    alert('Warehouse is required');
    return;
  }


  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }

  /*

  if (fiscalYearsData.includes(parseInt(fyname)) && uniqueWarehouses.some(name => name.toLowerCase() === warehousename.toLowerCase()) && uniqueProductsDescriptions.some(name => name.toLowerCase() === productdescription.toLowerCase())) {
    alert('This Product already exists for the current Fiscal Year and current warehouse. Please provide the Fiscal Year and Warehouse or modify the existing record');
    return;
  }

  */


  if (uniqueRowConcat.includes(`${fyname}${warehousename}${productdescription}${satellite || ""}`)) {
    alert('This record already exists. Modify your information or modify the existing record');
    return;
  }
  
  axiosService.post('/inventoriescreate/', {
    warehousename: this.state.warehousename,
    fyname: this.state.fyname,
    productdescription : this.state.productdescription,
    satellite: this.state.satellite,
    july : this.state.july,
    august : this.state.august,
    september : this.state.september,
    october : this.state.october,
    november : this.state.november,
    december : this.state.december,
    january : this.state.january,
    february : this.state.february,
    march : this.state.march,
    april : this.state.april,
    may : this.state.may,
    june : this.state.june
  })
    .then(result => {
      alert('Inventory created');
      this.refreshList();
      window.location.reload();
    })
    .catch(error => {
      alert('Failed');
    });
}

deleteClick(id) {
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/inventories/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        window.location.reload();
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      inventories,
      modalTitle,
      inventoryid,
      warehousename,
      fyname,
      productdescription,
      sapcode,
      satellite,
      july,
      august,
      september,
      october,
      november,
      december,
      january,
      february,
      march,
      april,
      may,
      june,
      loading,
      loadingExp,
      fiscalYears,
      currentYearIndex,
      currentYear,


      exp_inventories,
      inventoryexpid,
      //fyname,
      Fromwarehousename,
      Towarehousename,
      itemtypename,
		productid,
		//sapcode,
		//productdescription

    message,
    errors

  }=this.state;

  //const currentYear = fiscalYears[currentYearIndex];

  return(
    
<div className="scrollable-container">
<MyPage />
<SubTabsWarehouses />
<div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
      Real Inventory
    </div>

<button   type="button"
          className="btn btn-primary m-2 float-end"
          onClick={() => this.downloadCSV()}
          style={{  height: "28px", fontSize: "12px" ,textAlign:"center" ,    
                  cursor: this.state.isDownloading ? 'not-allowed' : 'pointer',
                  opacity: this.state.isDownloading ? 0.6 : 1
                }}
          disabled={this.state.isDownloading}

>
  {this.state.isDownloading ? 'Downloading...' : 'Download'}
</button>


<div className="d-flex flex-row align-items-center">
    <input
    disabled={!isSuperAdmin()}
    className="form-control m-2" 
    type="file" 
    style={{ width: "200px", height:"30px", fontSize: "12px" }}
    onChange={this.handleFileChange} />
    <button 
    disabled={!isSuperAdmin()}
    type="button"
    className="btn btn-primary m-2 float-end"
    style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
    onClick={this.handleUpload}>Upload File</button>
</div>

<div className="table-container" style={{ height: '700px' }}>
  <InventoriesTable
    inventories={inventories}
    loading={loading}
    showFilters={true}
    fiscalYearValue={currentYear}
    onFiscalYearChange={this.changeFiscalYearFilter}
    onWarehouseNameChange={this.changeWarehouseNameFilter}
    onCountryNameChange={this.changeCountryNameFilter}
    onProductIdChange={this.changeProductIdFilter}
    onProductDescriptionChange={this.changeProductDescriptionFilter}
    onSearch={this.searchInventories}
    onClear={this.clearFilters}
    onEdit={(dep) => this.editClick(dep)}
    onDelete={(id) => this.deleteClick(id)}
    onCopy={(dep) => this.editClick(dep)}
  />
</div>

<div style={{ 
  display: 'flex', 
  justifyContent: 'center', 
  alignItems: 'center', 
  gap: '10px', 
  padding: '20px',
  fontSize: '12px'
}}>
  <button 
    onClick={this.handlePreviousPage}
    disabled={!this.state.previousPageUrl || this.state.loading}
    className="btn btn-primary"
    style={{ height: "28px", fontSize: "12px" }}
  >
    Previous
  </button>
  
  <span style={{ fontSize: '12px' }}>
    Page {this.state.currentPage} of {this.state.totalPages}
  </span>
  
  <button 
    onClick={this.handleNextPage}
    disabled={!this.state.nextPageUrl || this.state.loading}
    className="btn btn-primary"
    style={{ height: "28px", fontSize: "12px" }}
  >
    Next
  </button>
</div>


<div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
      Planned Inventory
    </div>

    <div className="table-container">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeExpFiscalYearFilter}
      value={currentYear}
      placeholder="Filter"/>

      </div>
      Fiscal Year
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeExpWarehouseNameFilter}
      placeholder="Filter"/>
      </div>
      Warehouse
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeExpItemtypeNameFilter}
      placeholder="Filter"/>

      </div>
      ItemTypeName
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeExpSapCodeFilter}
      placeholder="Filter"/>
      </div>
      SAP Code
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
    <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
      style={{ width: "150px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
          onChange={this.changeExpProductDescriptionFilter}
          placeholder="Filter"/>
    </div>
      ProductDescription
  </th>
  



  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
    <div className="d-flex m-2 flex-row align-items-center justify-content-center gap-1">
      <button 
        type="button"
        className="btn btn-primary"
        style={{ fontSize: "12px" }}
        onClick={this.searchExpInventories}
      >
        Search
      </button>
      <button 
        type="button"
        className="btn btn-secondary"
        style={{ fontSize: "12px" }}
        onClick={this.clearFiltersExp}
      >
        Clear
      </button>
    </div>
    Jul
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug 
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep 
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct 
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov 
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec 
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan 
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb 
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar 
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr 
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May 
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun 
  </th>
</tr>
</thead>
{loadingExp ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {exp_inventories.map(dep=>
      <tr key={dep.inventoryexpid} className="row-hover">
          <td className="table-text">{dep.fyname ?? 'N/A'}</td>
          <td className="table-text">{dep.warehousename ?? 'N/A'}</td>
          <td className="table-text">{dep.itemtypename ?? 'N/A'}</td>
          <td className="table-text">{dep.sapcode ?? 'N/A'}</td>
          <td className="table-text">{dep.productdescription ?? 'N/A'}</td>
          <td className="table-text">{dep.july ?? 'N/A'}</td>
          <td className="table-text">{dep.august ?? 'N/A'}</td>
          <td className="table-text">{dep.september ?? 'N/A'}</td>
          <td className="table-text">{dep.october ?? 'N/A'}</td>
          <td className="table-text">{dep.november ?? 'N/A'}</td>
          <td className="table-text">{dep.december ?? 'N/A'}</td>
          <td className="table-text">{dep.january ?? 'N/A'}</td>
          <td className="table-text">{dep.february ?? 'N/A'}</td>
          <td className="table-text">{dep.march ?? 'N/A'}</td>
          <td className="table-text">{dep.april ?? 'N/A'}</td>
          <td className="table-text">{dep.may ?? 'N/A'}</td>
          <td className="table-text">{dep.june ?? 'N/A'}</td>
          <td>
          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
<div style={{ 
  display: 'flex', 
  justifyContent: 'center', 
  alignItems: 'center', 
  gap: '10px', 
  padding: '20px',
  fontSize: '12px'
}}>
  <button 
    onClick={this.handlePreviousPageExp}
    disabled={!this.state.previousPageUrlExp || this.state.loadingExp}
    className="btn btn-primary"
    style={{ height: "28px", fontSize: "12px" }}
  >
    Previous
  </button>
  
  <span style={{ fontSize: '12px' }}>
    Page {this.state.currentPageExp} of {this.state.totalPagesExp}
  </span>
  
  <button 
    onClick={this.handleNextPageExp}
    disabled={!this.state.nextPageUrlExp || this.state.loadingExp}
    className="btn btn-primary"
    style={{ height: "28px", fontSize: "12px" }}
  >
    Next
  </button>
</div>
</div>


<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }}>{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }}
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Warehouse</span>
          <select
            className="form-select"
            value={this.state.warehousename}
            onChange={(event) => this.setState({ warehousename: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }}
          >
            <option value="">Select a warehouse</option>
            {this.state.warehouseNames.map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Product SAP Code / SKU</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode = event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcode(selectedSapcode);
      this.setState({ productdescription: productdescription });
    }}
    disabled={this.state.isEditClicked}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select item SAPCODE</option>
    {this.state.SapcodeNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>
  
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Product</span>
  <input
    type="text"
    className={`form-control`}
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>

<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Satellite</span>
  <select
    className="form-select"
    value={this.state.satellite}
    onChange={(event) => this.setState({ satellite: event.target.value })}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select satellite</option>
    <option value="LEO">LEO</option>
    <option value="GEO">GEO</option>
  </select>
</div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        {inventoryid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {inventoryid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick(inventoryid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="exampleModal1" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }}>{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
            
            style={{ fontSize: "12px" }}
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Warehouse</span>
          <select
            className="form-select"
            value={this.state.warehousename}
            onChange={(event) => this.setState({ warehousename: event.target.value })}
         
            style={{ fontSize: "12px" }}
          >
            <option value="">Select a warehouse</option>
            {this.state.warehouseNames.map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Product SAP Code / SKU</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode = event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcode(selectedSapcode);
      this.setState({ productdescription: productdescription });
    }}
    
    style={{ fontSize: "12px" }}
  >
    <option value="">Select item SAPCODE</option>
    {this.state.SapcodeNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>
  
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Product</span>
  <input
    type="text"
    className={`form-control`}
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>




        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        {inventoryid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.copyClick()}>
            Create
          </button>
        ) : null}

        {inventoryid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.copyClick()}>
            Create
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="exampleModal2" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }}>{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }}
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Warehouse</span>
          <select
            className="form-select"
            value={this.state.warehousename}
            onChange={(event) => this.setState({ warehousename: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }}
          >
            <option value="">Select a warehouse</option>
            {this.state.warehouseNames.map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>SAP Code / SKU</span>
  <input
    type="text"
    className={`form-control`}
    value={this.state.sapcode} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ sapcode: event.target.value })} // Update productdescription state
    disabled={this.state.isEditClicked}
    
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>
  
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Product</span>
  <input
    type="text"
    className={`form-control`}
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    disabled={this.state.isEditClicked}
    
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>

<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Satellite</span>
  <select
    className="form-select"
    value={this.state.satellite}
    onChange={(event) => this.setState({ satellite: event.target.value })}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select satellite</option>
    <option value="LEO">LEO</option>
    <option value="GEO">GEO</option>
  </select>
</div>




        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        {inventoryid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {inventoryid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick(inventoryid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>
</div>
  )
}
  }




